import { baseUrl } from "../util/Endpoint";

const GetFetchZip = async (url, fileName) => {
  if (url) {
    const endpoint = baseUrl() + url;
    const user = JSON.parse(localStorage.getItem("user"));
    const email = user.email.toString().toLowerCase();

    var myHeaders = new Headers();
    myHeaders.append("accept", "application/zip");
    myHeaders.append("From", email);
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem("JWT_TOKEN"));

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    

    await fetch(endpoint, requestOptions)
      .then((response) => {
        response.blob().then((blob) => {

          // Creating new object of PDF file
          const fileURL = URL.createObjectURL(blob);

          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = fileName ? fileName : "Download.zip";
          alink.click();
          // document.body.removeChild(a);
          // URL.revokeObjectURL(url); // Clean up the URL object
        });
      })
      .then(result => console.log(result))
      .catch(error => console.log('error', error));
  }
}
export default GetFetchZip;